var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"app-wrap"},[_c('vHeader'),_c('el-container',{staticClass:"main-wrap"},[_c('vAside'),_c('el-main',[_c('vMain')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }